module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av545-7801125515d325c2de509897421e0ea9.jpg";